import {Price} from 'components/shared';
import {FC} from 'react';
import {IRequiredProduct} from 'types';

import {OrderTotalListItem} from '..';

interface IProps {
  requiredProducts: IRequiredProduct[];
}

export const CostRequiredProducts: FC<IProps> = ({requiredProducts}) => {
  return (
    <>
      {requiredProducts.map((item) => (
        <OrderTotalListItem key={item.name} boxProps={{borderBottom: '1px solid #E6E6E6'}} title={item.name}>
          <Price
            value={item.price}
            priceProps={{
              fontWeight: '500',
            }}
          />
        </OrderTotalListItem>
      ))}
    </>
  );
};
